import { Skeleton } from "@/components/ui/baseUi/skeleton"
import { cn } from "@/modules/lib/utils"
import { CheckmarkIcon } from "@images/svgIcons/checkmarkIcon"
import { ForbiddenIcon } from "@images/svgIcons/forbiddenIcon"
import { BoxStaffPermissions, BoxStaffRole } from "@modules/boxStaff/gateway/boxStaffDto"
import { roleBoxStaffPermissions } from "@modules/boxStaff/utils/boxStaffUtils"
import { word } from "@modules/core/utils/i18n"
import { SharedCoachRole } from "@modules/sharedCoach/gateway/sharedCoachDtos"
import { Text } from "@/components/ui/baseUi/text"

type role = BoxStaffRole | SharedCoachRole

// check: true means that the user has the permission
export const permissionsRole = [
  {
    role: BoxStaffRole.COACH,
    features: [
      {
        text: "box.staff.permissionsModal.feature.planning.seeTimetables",
        check: roleBoxStaffPermissions[BoxStaffRole.COACH].includes(BoxStaffPermissions.SEE_TIMETABLES),
      },
      {
        text: "box.staff.permissionsModal.feature.planning.seeSlots",
        check: roleBoxStaffPermissions[BoxStaffRole.COACH].includes(BoxStaffPermissions.MANAGE_SLOTS),
      },
      {
        text: "box.staff.permissionsModal.feature.programming.manageProgrammings",
        check: roleBoxStaffPermissions[BoxStaffRole.COACH].includes(BoxStaffPermissions.MANAGE_PROGRAMMING),
      },
      {
        text: "box.staff.permissionsModal.feature.offers.seeList",
        check: roleBoxStaffPermissions[BoxStaffRole.COACH].includes(BoxStaffPermissions.SEE_OFFERS),
      },
      {
        text: "box.staff.permissionsModal.feature.members.seeListofLeads",
        check: roleBoxStaffPermissions[BoxStaffRole.COACH].includes(BoxStaffPermissions.SEE_LEADS),
      },
      {
        text: "box.staff.permissionsModal.feature.members.seeStaffMember",
        check: roleBoxStaffPermissions[BoxStaffRole.COACH].includes(BoxStaffPermissions.SEE_STAFF),
      },
    ],
  },
  {
    role: BoxStaffRole.CO_OWNER,
    features: [
      {
        text: "huPermissions.features.coOwner.feature1",
        check: roleBoxStaffPermissions[BoxStaffRole.CO_OWNER].includes(BoxStaffPermissions.MANAGE_SLOTS),
      },
      {
        text: "huPermissions.features.coOwner.feature2",
        check: roleBoxStaffPermissions[BoxStaffRole.CO_OWNER].includes(BoxStaffPermissions.MANAGE_PROGRAMMING),
      },
      {
        text: "huPermissions.features.coOwner.feature3",
        check: roleBoxStaffPermissions[BoxStaffRole.CO_OWNER].includes(BoxStaffPermissions.EDIT_OFFER),
      },
      {
        text: "huPermissions.features.coOwner.feature4",
        check: roleBoxStaffPermissions[BoxStaffRole.CO_OWNER].includes(BoxStaffPermissions.DELETE_GYM),
      },
      {
        text: "huPermissions.features.coOwner.feature5",
        check: roleBoxStaffPermissions[BoxStaffRole.CO_OWNER].includes(BoxStaffPermissions.EDIT_MEMBER),
      },
      {
        text: "huPermissions.features.coOwner.feature6",
        check: roleBoxStaffPermissions[BoxStaffRole.CO_OWNER].includes(BoxStaffPermissions.DELETE_GYM),
      },
      {
        text: "huPermissions.features.coOwner.feature7",
        check: roleBoxStaffPermissions[BoxStaffRole.CO_OWNER].includes(BoxStaffPermissions.SEE_FINANCIAL),
      },
    ],
  },
  {
    role: BoxStaffRole.OWNER,
    features: [
      {
        text: "huPermissions.features.coOwner.feature1",
        check: roleBoxStaffPermissions[BoxStaffRole.OWNER].includes(BoxStaffPermissions.MANAGE_SLOTS),
      },
      {
        text: "huPermissions.features.coOwner.feature2",
        check: roleBoxStaffPermissions[BoxStaffRole.OWNER].includes(BoxStaffPermissions.MANAGE_PROGRAMMING),
      },
      {
        text: "huPermissions.features.coOwner.feature3",
        check: roleBoxStaffPermissions[BoxStaffRole.OWNER].includes(BoxStaffPermissions.EDIT_OFFER),
      },
      {
        text: "huPermissions.features.coOwner.feature5",
        check: roleBoxStaffPermissions[BoxStaffRole.OWNER].includes(BoxStaffPermissions.EDIT_MEMBER),
      },
      {
        text: "huPermissions.features.coOwner.feature7",
        check: roleBoxStaffPermissions[BoxStaffRole.OWNER].includes(BoxStaffPermissions.SEE_FINANCIAL),
      },
      {
        text: "huPermissions.features.owner.feature1",
        check: roleBoxStaffPermissions[BoxStaffRole.OWNER].includes(BoxStaffPermissions.EDIT_GYM_INFORMATION),
      },
    ],
  },
  {
    role: BoxStaffRole.HEAD_COACH,
    features: [
      { text: "huPermissions.features.headCoach.feature1", check: true },
      {
        text: "box.staff.permissionsModal.feature.planning.addSlot",
        check: roleBoxStaffPermissions[BoxStaffRole.HEAD_COACH].includes(BoxStaffPermissions.MANAGE_SLOTS),
      },
      {
        text: "box.staff.permissionsModal.feature.planning.createActivity",
        check: roleBoxStaffPermissions[BoxStaffRole.HEAD_COACH].includes(BoxStaffPermissions.CREATE_ACTIVITY),
      },
      {
        text: "box.staff.permissionsModal.feature.planning.editSlots",
        check: roleBoxStaffPermissions[BoxStaffRole.HEAD_COACH].includes(BoxStaffPermissions.MANAGE_SLOTS),
      },
      {
        text: "box.staff.permissionsModal.feature.planning.editSession",
        check: roleBoxStaffPermissions[BoxStaffRole.HEAD_COACH].includes(BoxStaffPermissions.MANAGE_PROGRAMMING),
      },
      {
        text: "box.staff.permissionsModal.feature.members.editMemberFile",
        check: roleBoxStaffPermissions[BoxStaffRole.HEAD_COACH].includes(BoxStaffPermissions.EDIT_MEMBER),
      },
    ],
  },
  {
    role: BoxStaffRole.FINANCIAL,
    features: [
      {
        text: "huPermissions.features.coOwner.feature7",
        check: roleBoxStaffPermissions[BoxStaffRole.FINANCIAL].includes(BoxStaffPermissions.SEE_FINANCIAL),
      },
    ],
  },
  {
    role: SharedCoachRole.STANDARD,
    features: [
      { text: "invitationDetailsInfo.createSessions", check: true },
      { text: "invitationDetailsInfo.editSessions", check: true },
      { text: "invitationDetailsInfo.waitingRoomManagement", check: true },
      { text: "invitationDetailsInfo.accessToProgramSetting", check: false },
    ],
  },
]

export type HuPermissionsProps = {
  title?: string
  button?: React.JSX.Element
  role?: role // if role is missing the component will show a skeleton
  className?: string
} & React.ComponentProps<"div">

export function HuPermissions({ role, title, button, className, ...props }: HuPermissionsProps) {
  return (
    <div className={cn("flex flex-col", className)} {...props}>
      <div className="flex flex-row items-center">
        {title && (
          <Text fontStyle="LS" className="flex flex-row items-end text-textDefault-caption">
            {title.toUpperCase()}
          </Text>
        )}
        {button}
      </div>
      {!role ? (
        <div className="flex w-full">
          <Skeleton className="h-48 rounded-md" />
        </div>
      ) : (
        <div className="mx-2 mt-2 flex w-full justify-between rounded-xl bg-neutral-50 p-6">
          <div className="flex w-full flex-wrap">
            {permissionsRole
              .find((p) => p.role === role)
              ?.features.map((feature, index) => (
                <div
                  key={index}
                  className={`flex w-1/2 flex-row items-center gap-2 px-3 py-2 ${
                    index % 2 ? "" : "border-r"
                  } border-neutral-200`}
                >
                  {feature.check ? (
                    <CheckmarkIcon color="currentColor" className="size-5 shrink-0 text-lightGreen-500" />
                  ) : (
                    <ForbiddenIcon color="currentColor" className="size-5 shrink-0 text-red-500" />
                  )}

                  <Text fontStyle="LM" className="text-textDefault-caption">
                    {word(feature.text as any)}
                  </Text>
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  )
}
